<script setup lang="ts">
/** Multi-step: two to four labelled blanks, each with a keypad-typeable answer, graded by position. */
import type { InputPrimaryEvent } from '@shared/ui/fields'
import type { MathExerciseEditorProps } from '../../../../../model/assignments/math-exercise-editors.hook'

import { AppText } from '@shared/ui/typography'
import { InputPrimary } from '@shared/ui/fields'

import { KEYPAD_HINT, isUntypeableAnswer } from '../../../../../model/assignments/math-exercise-editors.hook'
import { MATH_MULTI_STEP_MAX_STEPS, MATH_MULTI_STEP_MIN_STEPS } from '../../../../../lib/assignments/math-practice-schema'
import ExerciseItemList from '../ExerciseItemList.vue'

defineOptions({
  name: 'ExerciseMultiStep',
})

defineProps<MathExerciseEditorProps>()
</script>

<template>
  <div class="exercise-multi-step">
    <AppText
      name="body2"
      color="slate-500"
    >
      {{ MATH_MULTI_STEP_MIN_STEPS }} to {{ MATH_MULTI_STEP_MAX_STEPS }} steps. {{ KEYPAD_HINT }}
    </AppText>
    <ExerciseItemList
      :exercise="exercise"
      list="steps"
      noun="step"
      label="Steps"
      :min="MATH_MULTI_STEP_MIN_STEPS"
      :max="MATH_MULTI_STEP_MAX_STEPS"
    >
      <template #item="{ row, update }">
        <InputPrimary
          name="step-label"
          class-name="exercise-multi-step__label"
          :value="row.values.label"
          placeholder="e.g. 12 + 8 ="
          @input="(event: InputPrimaryEvent) => update({ label: String(event.value) })"
        />
        <InputPrimary
          name="step-answer"
          class-name="exercise-multi-step__answer"
          :value="row.values.answer"
          :mode="isUntypeableAnswer(row.values.answer ?? '') ? 'error' : 'normal'"
          placeholder="Answer"
          @input="(event: InputPrimaryEvent) => update({ answer: String(event.value) })"
        />
      </template>
    </ExerciseItemList>
  </div>
</template>

<style scoped lang="scss" src="./ExerciseMultiStep.scss" />
